import { render, staticRenderFns } from "./carousel-pagination.vue?vue&type=template&id=43bcbe53&scoped=true&lang=pug"
import script from "./carousel-pagination.vue?vue&type=script&lang=coffee"
export * from "./carousel-pagination.vue?vue&type=script&lang=coffee"
import style0 from "./carousel-pagination.vue?vue&type=style&index=0&id=43bcbe53&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bcbe53",
  null
  
)

export default component.exports